import {createStore, applyMiddleware, compose} from 'redux';
import Rehydration from './Rehydration';
import ReduxPersist from './ReduxPersistConfig';
import { composeWithDevTools } from '@redux-devtools/extension';
import reduxReset from 'redux-reset';
import createSagaMiddleware from 'redux-saga';

// creates the store
export default (rootReducer, rootSaga) => {
    /* ------------- Redux Configuration ------------- */

    const middleware = [];
    const enhancers = [];

    /* ------------- Saga Middleware ------------- */

    const sagaMonitor = null;
    const sagaMiddleware = createSagaMiddleware({sagaMonitor});
    middleware.push(sagaMiddleware);

    /* ------------- Assemble Middleware ------------- */

    enhancers.push(applyMiddleware(...middleware));

    // Redux DevTools: use as a compose replacement by passing enhancers directly
    const store = createStore(
        rootReducer,
        composeWithDevTools(
            compose(
                ...enhancers,
                reduxReset()
            )
        )
    );

    // configure persistStore and check reducer version number
    if (ReduxPersist.active) {
        Rehydration.updateReducers(store)
    }

    // kick off root saga
    let sagasManager = sagaMiddleware.run(rootSaga);

    return {
        store,
        sagasManager,
        sagaMiddleware
    };
};
